<div [ngClass]="elements>5?'example-container':'none'">

  <div style="overflow-x:auto;">
    <table role="table">

      <thead role="rowgroup">
        <tr role="row">
          <th *ngFor="let column of columns" role="columnheader">
            <button [attr.guide]="'leadsmeeting-btn-1' + '__' + sanitizedUrl" type="button" (click)="sortData({active: column.property})" class="header-sort">
              {{ column.name }}
            </button>
          </th>
        </tr>
      </thead>
      <tbody role="rowgroup">
        <tr *ngFor="let row of googleCalendarList" role="row" class="clickable">
          <td *ngFor="let column of columns" role="cell" [attr.data-label]="column.name" [ngClass]="column.cssClasses">

            <ng-container *ngIf="column.property === 'summary'">
              <div class="description-header" (click)="toggleSummary(row)">
                <span class="description-text" [class.expanded]="row.showFullSummary" [title]="row.summary">
                  {{ row.summary }}
                </span>
                <span class="material-icons-outlined arrow-icon" [class.open]="row.showFullSummary" *ngIf="row.summary && row.summary.length > 25">
                  keyboard_arrow_down
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="column.property === 'createdDate'">
              {{ row.createdDate | calsoftDate }}
            </ng-container>

            <ng-container *ngIf="column.property === 'updatedDate'">
              {{ row.updatedDate | calsoftDate }}
            </ng-container>

            <ng-container *ngIf="column.property === 'description'">
              <div class="description-header" (click)="toggleDescription(row)">
                <span class="description-text" [class.expanded]="row.showFullDescription" [title]="row.description">
                  {{ row.description }}
                </span>

                <span class="material-icons-outlined arrow-icon" [class.open]="row.showFullDescription" *ngIf="row.description && row.description.length > 25">
                  keyboard_arrow_down
                </span>
              </div>
            </ng-container>


            <ng-container *ngIf="column.property === 'meetLink'">


              <button *ngIf="row.meetLink" [attr.guide]="'leadsmeeting-btn-copy-link' + '__' + sanitizedUrl" type="button" (click)="copyToClipboard(row.meetLink)" aria-label="Copy link">
                <mat-icon>content_copy</mat-icon>
              </button>

            </ng-container>

            <ng-container *ngIf="column.property === 'startDateTime'">
              {{row.startDateTime | calsoftDate}}
            </ng-container>

            <ng-container *ngIf="column.property === 'endTime'">
              {{formatTime12(row.endTime) }}
            </ng-container>

            <ng-container *ngIf="column.property === 'startTime'">
              {{formatTime12(row.startTime) }}
            </ng-container>

            <ng-container *ngIf="column.property === 'error'">
              <div class="description-header" (click)="toggleError(row)" *ngIf="row.error">
                <span class="description-text" [class.expanded]="row.showFullError" style="white-space: pre-line; word-break: break-word;" [title]="row.error">
                  {{ row.error }}
                </span>
                <span class="material-icons-outlined arrow-icon" [class.open]="row.showFullError">
                  keyboard_arrow_down
                </span>
              </div>
            </ng-container>

            <ng-container
              *ngIf="column.property !== 'actions' && column.property !== 'summary' && column.property !== 'description'  && column.property !== 'endDateTime' && column.property !== 'startTime' && column.property !== 'endTime' && column.property !== 'createdDate' && column.property !== 'startDateTime' && column.property !== 'updatedDate' && column.property !== 'meetLink' && column.property !== 'error'">
              <span class="truncate">{{ row[column.property] }}</span>
            </ng-container>

            <ng-container *ngIf="column.property === 'actions'">
              <div class="actions-cell">
                <button [attr.guide]="'leadsmeeting-btn-2' + '__' + sanitizedUrl" type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                  (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                  <button [attr.guide]="'leadsmeeting-btn-3' + '__' + sanitizedUrl" (click)="editGoogleCalendar(row.googleCalenderId, row.type)" mat-menu-item>
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                </mat-menu>
              </div>
            </ng-container>

          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="products-padding" fxLayoutAlign="center center" *ngIf="!googleCalendarList?.length">
    No records found
  </div>

  <div *ngIf="googleCalendarList?.length>0" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
      [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue"> </mat-paginator>
  </div>

</div>